import { useEffect, useState } from "react";
import * as localCookiesAlertFisia from "../service/localStorage/alertFisia";

export default function useAlertFisiaConsent() {
  const [cookiesAlertFisia, setCookiesAlertFisia] = useState(false);

  useEffect(() => {
    const cookiesConsentData = localCookiesAlertFisia.get();

    if (cookiesConsentData && cookiesConsentData.date) {
      const dateBeforeDays = new Date();
      dateBeforeDays.setDate(dateBeforeDays.getDate() - 15);

      if (new Date(cookiesConsentData.date) < dateBeforeDays) {
        setCookiesAlertFisia(false);
      } else {
        setCookiesAlertFisia(true);
      }
    }

    // eslint-disable-next-line
  }, [localCookiesAlertFisia.get()]);

  useEffect(() => {
    if (cookiesAlertFisia) {
      localCookiesAlertFisia.set({ date: new Date() });
    }
  }, [cookiesAlertFisia]);

  return { cookiesAlertFisia, setCookiesAlertFisia };
}
